exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* overridden by src/lib/themes/guiHelpers.js */\r\n\r\n.waveform_container_243I7 {\r\n    width: 100%;\r\n}\r\n\r\n.waveform_waveform-path_2LeiM {\r\n    /*\r\n        This color is lighter than sound-primary, but\r\n        cannot use alpha because of overlapping elements.\r\n    */\r\n    fill: hsl(300, 54%, 72%);\r\n    stroke: var(--sound-tertiary);\r\n}\r\n\r\n.waveform_baseline_2hE-m {\r\n    stroke: var(--sound-tertiary);\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "waveform_container_243I7",
	"waveform-path": "waveform_waveform-path_2LeiM",
	"waveformPath": "waveform_waveform-path_2LeiM",
	"baseline": "waveform_baseline_2hE-m"
};